/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/file_warning'
export default icon
